import styled from 'styled-components'

export const CalendarWrapper = styled.div``
